import { ContainerTooltip, TextTooltip } from './PunchupNetSales.styles';
import { FC, memo } from 'react';

import { CustomTooltipProps } from './types';
import moment from 'moment';
import { toUsFormat } from 'utils/utils';

const PunchupCustomTooltip: FC<CustomTooltipProps> = ({ label, data }: CustomTooltipProps) => {
	const option = data?.find(({ date }) => date.valueOf() === label?.valueOf());

	if (option) {
		return (
			<ContainerTooltip>
				<TextTooltip element="p">
					{moment(option.date).format('MM/DD/YY')}
					<br />
					{toUsFormat(option.payout)}
				</TextTooltip>
			</ContainerTooltip>
		);
	}

	return null;
};

const memorizedCustomTooltip: FC<CustomTooltipProps> = memo(PunchupCustomTooltip);

export { memorizedCustomTooltip as PunchupCustomTooltip };
